"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _ModalContext = require("../ModalContext");

var useModalContextFunctions = function useModalContextFunctions() {
  var _useContext = (0, _react.useContext)(_ModalContext.ModalContext),
      callContextFunctions = _useContext.callContextFunctions;

  (0, _react.useEffect)(function () {
    if (callContextFunctions) callContextFunctions();
  }, [callContextFunctions]);
};

var _default = useModalContextFunctions;
exports.default = _default;